export default {
    name: 'phonefetchingservice',
    dependencies: ['reqwest', 'sitesettings', 'xhrservice'],
    callable(reqwest, sitesettings, xhrservice) {
        let phoneNumberAux;

        function json(path, data) {
            return xhrservice.request({
                url: path,
                type: 'json',
                data,
            });
        }

        function makeResponseHandler(propName) {
            return function(response) {
                const result =
                    (response.result && response.result.result) ||
                    response.result;

                if (result && result[propName] === 'OK') {
                    return result;
                } else {
                    throw makeError(
                        result[propName] || result.message,
                        response,
                        result.message
                    );
                }
            };
        }

        function makeError(status, response, message) {
            return { status, response, message: message || status };
        }

        function getNumber(adId) {
            return json('/verification/properties/phonenumbers.json', {
                adId,
            }).then(makeResponseHandler('verified'), onNetworkError);
        }

        function requestPin(phoneNumber) {
            phoneNumberAux = phoneNumber;
            return json('/verification/properties/requestpincode.json', {
                phoneNumber: phoneNumberAux,
            }).then(makeResponseHandler('sendPinStatus'), onNetworkError);
        }

        function validatePin(pin) {
            return json('/verification/properties/validatepin.json', {
                pin,
                phoneNumber: phoneNumberAux,
            }).then(makeResponseHandler('validationStatus'), onNetworkError);
        }

        function onNetworkError(err) {
            console.log('network error', err);
            throw err;
        }

        return {
            getNumber,
            requestPin,
            validatePin,
        };
    },
};



// WEBPACK FOOTER //
// ./services/phoneFetchingService.js